import request from '@/utils/request';

function apiGetStockListForStockLocation(params, stockLocationID, domainID) {
  return request({
    method: 'get',
    params: {
      limit: params.query.limit,
      page: params.query.page,
      description: params.query.productDescription || '',
      code: params.query.productCode || '',
      stockLocationID: stockLocationID,
      domainID: domainID
    },
    url: '/stock/ReadManyStocksIncludingNonExistentStocks'
  });
}

function apiSubmitStockCorrections(stockCorrections) {
  return request({
    data: stockCorrections,
    method: 'post',
    url: '/stockcorrection/CreateBulk'
  });
}

function apiSetStockTask(domainID) {
  return request({
    method: 'post',
    params: {
      domainID: domainID
    },
    url: '/stockcorrection/SetStockTask',
    timeout: 180000
  });
}

export const storeExtensions = {
  actions: {
    readStocksIncludingNonExistent({ dispatch }, { listParams, stockLocationID, domainID } = {}) {
      return apiGetStockListForStockLocation(listParams, stockLocationID, domainID);
    },
    submitStockCorrections({ commit }, stockCorrections) {
      return apiSubmitStockCorrections(stockCorrections);
    },
    setStockTask({ dispatch }, { domainID }) {
      return apiSetStockTask(domainID);
    }
  }
};
